import { MjmlColumn, MjmlSection, MjmlText } from "@faire/mjml-react";
import { populateVariables } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { Section, SharedProps } from "@redotech/redo-model/email-builder";
import htmlReactParser from "html-react-parser";
import { memo } from "react";
import { processQuillHtml } from "./text";

export type MenuState = Section.Menu & SharedProps;

export const EmailMenu = memo(function EmailMenu(props: MenuState) {
  const padding = props.sectionPadding;

  return (
    <MjmlSection
      backgroundColor={props.sectionColor}
      paddingBottom={padding.bottom}
      paddingLeft={padding.left}
      paddingRight={padding.right}
      paddingTop={padding.top}
    >
      {props.menuItems.map((item, index) => {
        const quillHtml = processQuillHtml(item.label, props.linkColor);
        // the email builder doesn't use this component to render,
        // but just in case
        const text = props.isBuilder
          ? quillHtml
          : populateVariables(quillHtml, props.schemaInstance);

        return (
          <MjmlColumn key={index}>
            <MjmlText
              color={props.textColor}
              fontFamily={props.fontFamily}
              fontSize={props.fontSize}
            >
              {htmlReactParser(text)}
            </MjmlText>
          </MjmlColumn>
        );
      })}
    </MjmlSection>
  );
});
